import './element'

// 全局通用组件
const listArr = []

const install = Vue => {
  listArr.forEach(item => Vue.component(item.name, item))
}
export default install
